export function removeHash(filepath: string) {
  const hashReg = /-[^-]*.(css|js)/;
  return filepath.replace(hashReg, '');
}

export function removeHashAndExtension(filepath: string) {
  const arr = filepath.split('/');
  const before = arr.slice(0, arr.length - 1);
  const last = arr[arr.length - 1];
  const removed = last.split(/[.|-]/g).shift() || '';
  if (before.length) {
    return `${before.join('/')}/${removed}`;
  }
  return removed;
}
